import { useContext, useEffect } from 'react';
import { LayoutContext } from '@/_shared/components/PageLayout';
import { Assessment, Tutorial } from '../components';

export const AssessmentDetailScreen = () => {
  const { setLayout } = useContext(LayoutContext);

  useEffect(() => {
    setLayout({ title: 'assessments' });
  }, [setLayout]);

  return (
    <>
      <Assessment />
      <Tutorial />
    </>
  );
};
